var _g, _path, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5035_34311)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.335449,
    y: 0.0117188,
    width: 62,
    height: 62,
    rx: 31,
    fill: "url(#paint0_linear_5035_34311)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.835449,
    y: 0.511719,
    width: 61,
    height: 61,
    rx: 30.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M35.5243 25.8875L35.1259 23.5128C35.0462 23.0352 35.2009 22.5481 35.5431 22.206L37.9431 19.806C38.2853 19.4251 38.9696 19.5575 39.1712 20.0577L40.2493 22.7516L42.9446 23.7875C43.4415 24.0313 43.5353 24.6735 43.1931 25.0578L40.7931 27.4578C40.4509 27.8 39.9634 27.9125 39.4899 27.875L37.1134 27.4766L32.754 31.7563C32.3556 32.2344 31.6431 32.2344 31.2024 31.7563C30.7665 31.3578 30.7665 30.6453 31.2024 30.2047L35.5243 25.8875Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_5035_34311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7456 29.4372C37.015 29.1678 37.3981 29.0453 37.7739 29.1083C38.2262 29.1842 38.6028 29.5146 38.6723 29.968C38.7238 30.3037 38.75 30.648 38.75 31C38.75 34.7266 35.7266 37.75 32 37.75C28.2734 37.75 25.25 34.7266 25.25 31C25.25 27.2734 28.2734 24.25 32 24.25C32.3312 24.25 32.6555 24.2732 32.9723 24.3122C33.4533 24.3714 33.8187 24.7591 33.8966 25.2374C33.9566 25.6063 33.8355 25.9817 33.5712 26.246L32.909 26.9082C32.67 27.1472 32.338 27.2078 32 27.2078C29.9281 27.2078 28.25 28.9281 28.25 30.9578C28.25 33.0719 29.9281 34.75 32 34.75C34.0719 34.75 35.75 33.0719 35.75 30.9578C35.75 30.6495 35.8405 30.3424 36.0585 30.1243L36.7456 29.4372ZM41.4663 28.9024C42.3203 28.0485 43.7629 28.4065 43.9115 29.605C43.9684 30.0643 44 30.5314 44 31C44 37.6281 38.6281 43 32 43C25.3719 43 20 37.6281 20 31C20 24.3719 25.3719 19 32 19C32.4764 19 32.9462 19.0278 33.408 19.0818C34.6146 19.2229 34.9639 20.6659 34.1049 21.5249C33.7283 21.9016 33.1934 22.0627 32.6622 22.024C32.4432 22.0081 32.2225 22 32 22C26.9891 22 23 25.9891 23 31C23 35.9688 26.9891 40 32 40C36.9688 40 41 35.9688 41 31C41 30.7739 40.9917 30.5497 40.9752 30.3273C40.9363 29.8029 41.0945 29.2743 41.4663 28.9024Z",
    fill: "url(#paint1_linear_5035_34311)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0992 29.7908C37.2543 29.6357 37.4748 29.5651 37.6911 29.6014C37.9653 29.6474 38.1463 29.8365 38.1781 30.0438C38.2257 30.3539 38.25 30.6729 38.25 31C38.25 34.4504 35.4504 37.25 32 37.25C28.5496 37.25 25.75 34.4504 25.75 31C25.75 27.5496 28.5496 24.75 32 24.75C32.3079 24.75 32.6116 24.7715 32.9112 24.8084C33.1487 24.8377 33.3571 25.035 33.4031 25.3177C33.4373 25.5279 33.3683 25.7418 33.2176 25.8924L32.5554 26.5547C32.4588 26.6513 32.2953 26.7078 32 26.7078C29.6483 26.7078 27.75 28.6556 27.75 30.9578C27.75 33.3444 29.6483 35.25 32 35.25C34.3517 35.25 36.25 33.3444 36.25 30.9578C36.25 30.7388 36.3145 30.5754 36.412 30.4779L37.0992 29.7908ZM41.8199 29.256C42.1188 28.9571 42.5073 28.8806 42.8218 28.9664C43.126 29.0494 43.3677 29.2825 43.4153 29.6666C43.4699 30.1073 43.5 30.5537 43.5 31C43.5 37.352 38.352 42.5 32 42.5C25.648 42.5 20.5 37.352 20.5 31C20.5 24.648 25.648 19.5 32 19.5C32.457 19.5 32.9074 19.5266 33.35 19.5784C33.7372 19.6237 33.9673 19.8633 34.0483 20.1641C34.1324 20.4768 34.0547 20.868 33.7514 21.1714C33.4945 21.4283 33.1107 21.5554 32.6985 21.5254C32.4675 21.5085 32.2346 21.5 32 21.5C26.7129 21.5 22.5 25.7129 22.5 31C22.5 36.2434 26.7114 40.5 32 40.5C37.2449 40.5 41.5 36.2449 41.5 31C41.5 30.7617 41.4913 30.5251 41.4738 30.2902C41.4437 29.8846 41.5682 29.5076 41.8199 29.256Z",
    stroke: "white",
    strokeOpacity: 0.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5035_34311",
    x: -4.66455,
    y: -4.98828,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_5035_34311",
    x: -2,
    y: -3,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5035_34311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5035_34311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5035_34311",
    x1: -2.24789,
    y1: 64.0784,
    x2: 34.1163,
    y2: -4.06144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23261,
    stopColor: "#6E4AFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839719,
    stopColor: "#EF5EF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5035_34311",
    x1: 21.7252,
    y1: 21.0679,
    x2: 49.0807,
    y2: 31.9424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPm);
export default __webpack_public_path__ + "static/media/PM.0c4205626cf22900ff0e372c31d2a6b4.svg";
export { ForwardRef as ReactComponent };